let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fZyYv")).then(() => parcelRequire('7PP2u'));